export class deliveryUrlList {
  // Bookings Start
  taxiBookings: string = "/admin/taxi/bookings";
  // Bookings End
}
